import { Input } from 'components/Input/Input'
import { Container, ContainerContent, ContainerHeader, PersonChip } from '../Accommodation.style'
import { Box, Flex } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { LocationIcon } from '../icons/LocationIcon'
import { NextIcon } from '../icons/NextIcon'
import { CalendarIcon } from '../icons/CalendarIcon'

export const CheckOut = () => {


    const Bed = () => {
        return <Box style={{ cursor: 'pointer' }} >
            <Flex column gap='1rem' >
                <Flex width='100%' between >
                    <TitleText>John Smith</TitleText>
                    <PersonChip type='Guest'>Guest</PersonChip>
                </Flex>
                <Flex gap='0.5rem ' >
                    <LocationIcon />
                    <BodyText grey > North Camp </BodyText>
                    <NextIcon />
                    <BodyText grey > Block B</BodyText>
                    <NextIcon />
                    <BodyText grey > Room 2</BodyText>
                    <NextIcon />
                    <BodyText color='#ff9900' > Bed 1</BodyText>
                </Flex>
                <OtherText grey >Male •  Standard</OtherText>
                <Flex width='100%' between >
                    <Flex gap='1rem' >
                        <Flex gap='0.5rem' center >
                            <CalendarIcon />
                            <OtherText grey>In: Feb 2, 2025</OtherText>
                        </Flex>
                        <Flex gap='0.5rem' center >
                            <CalendarIcon />
                            <OtherText grey>Out: Feb 2, 2025</OtherText>
                        </Flex>
                    </Flex>
                    <BodyText color='#24D07B' >7 Days Remaining</BodyText>
                </Flex>
            </Flex>
        </Box>
    }

    return <>
        <Input search placeholder='Serch by name' />
        <Container>
            <ContainerHeader padding>
                <Flex column gap='1rem' >
                    <TitleText>Currently Occupied Beds</TitleText>
                    <Flex gap='1rem' >
                        <HonestSelectInput width='200px' nomarg options={[]} onChange={null} labelText='Camp' />
                        <HonestSelectInput width='200px' nomarg options={[]} onChange={null} labelText='Tier' />
                    </Flex>
                </Flex>
            </ContainerHeader>
            <ContainerContent gap='1rem' >
                <Bed />
                <Bed />
                <Bed />
                <Bed />
                <Bed />
            </ContainerContent>
        </Container>
    </>
}